import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const ContactUs = () => {
  return (
    <div>
      <Navbar />
       <section className="in_page p70 bg4 ">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <h1 className="hadding">Contact Us</h1>
              <p>We’d love to learn about your project and explore how Dyntech can help you succeed. 
                Please choose the relevant channel below:</p>
             </div>
             <div className="col-md-4 m-auto col-8">
              <img src="/img/contact-us.png"  alt="Contact Us" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <section className="in_page p70">
        <div className="container">
           
          <div className="row ">
            <div className="col-md-8 mb-4 text-center">
              <div className="bg2 br20 p-3 p-md-4 contact_box h100" >
                
          <div className="row ">
            <div className="col-md-4 mb-3 mb-md-0">
             <i className="bi bi-chat-left-text"></i>  
              <h5>Inquiry Type</h5>
              <p className="mb-0">Support & Technical</p> 
            </div>
             <div className="col-md-4 mb-3 mb-md-0">
              <i className="bi bi-envelope"></i>  
              <h5>Email</h5>
              <p className="mb-0"><a href="mailto:support@dyntech.com">support@dyntech.com</a></p>
             </div>  
             <div className="col-md-4 mb-3 mb-md-0">
               <i className="bi bi-clock"></i>
              <h5>Response Time</h5>
              <p className="mb-0">Within 4 hours</p>
            </div>
            </div> 
          
             </div>
             </div>
             <div className="col-md-4 mb-4">
              <div className="bg2 br20 p-3 p-md-4 h100 ">
            <h3 className="mb-3">Office Locations</h3>
            <h6 className="mb-3">General Enquiries: <a className=" ml-2" href="callto:+919619892484">+91-9619892484</a></h6>
            <h6>Follow Us:
              <a className="mr-2 ml-3" href="#"><i class="bi bi-linkedin"></i> </a>
              <a className="mr-2" href="#"> <i class="bi bi-twitter-x"></i></a>
              <a className="mr-2" href="#"><i class="bi bi-facebook"></i> </a>
              </h6>
             </div>
             </div>
             
             
          </div>


        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ContactUs;
